<template>
  <ul class="header-companies-skeleton">
    <li v-for="n in count" :key="n" class="header-companies-skeleton__item">
      <PSkeleton class="header-companies-skeleton__logo" shape="circle" />
      <STextSkeleton width="60px" />
      <STextSkeleton width="40px" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { PSkeleton, STextSkeleton } from "@solvari/components";

withDefaults(defineProps<{ count?: number }>(), { count: 6 });
</script>

<style lang="postcss">
.header-companies-skeleton {
  @apply flex overflow-hidden pb-2 gap-4;

  &__item {
    @apply flex shrink-0 items-center gap-2;
  }

  &__logo {
    @apply h-8 w-8;
  }
}
</style>
